export default __webpack_public_path__ + "static/media/transactions.88bede14.svg";